// Stolen with love from https://github.com/egoist/vue-content-loader

import { CreateElement, VNode } from 'vue/types/umd'

// Handy online tool to create new loaders: https://create-vue-content-loader.netlify.com/  (11.03.2019)
const uid = () => Math.random().toString(36).substring(2)

export default {
  name: 'ContentLoader',

  functional: true,

  props: {
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 130,
    },
    isFillContainer: {
      type: Boolean,
      default: false,
    },
    speed: {
      type: Number,
      default: 2,
    },
    preserveAspectRatio: {
      type: String,
      default: 'xMinYMin meet',
    },
    primaryColor: {
      type: String,
      default: '#f9f9f9',
    },
    secondaryColor: {
      type: String,
      default: '#ecebeb',
    },
    uniqueKey: {
      type: String,
    },
    animate: {
      type: Boolean,
      default: true,
    },
    rx: {
      type: Number,
      default: 2,
    },
    ry: {
      type: Number,
      default: 2,
    },
  },

  render(
    h: CreateElement,
    { props, children }: { props: any; children: any },
  ): VNode {
    const idClip = props.uniqueKey ? `${props.uniqueKey}-idClip` : uid()
    const idGradient = props.uniqueKey ? `${props.uniqueKey}-idGradient` : uid()

    const viewPortWidth = props.isFillContainer ? 100 : props.width
    const viewPortHeight = props.isFillContainer ? 100 : props.height
    const width = props.isFillContainer ? '100%' : props.width
    const height = props.isFillContainer ? '100%' : props.height

    const preserveAspectRatio = props.isFillContainer
      ? 'none'
      : props.preserveAspectRatio

    return (
      <svg
        viewBox={`0 0 ${viewPortWidth} ${viewPortHeight}`}
        version="1.1"
        preserveAspectRatio={preserveAspectRatio}
      >
        <rect
          style={{ fill: `url(#${idGradient})` }}
          clip-path={`url(#${idClip})`}
          x="0"
          y="0"
          width={width}
          height={height}
        />

        <defs>
          <clipPath id={idClip}>
            {children || (
              <rect
                x="0"
                y="0"
                rx={props.rx}
                ry={props.ry}
                width={width}
                height={height}
              />
            )}
          </clipPath>

          <linearGradient id={idGradient}>
            <stop offset="0%" stop-color={props.primaryColor}>
              {props.animate ? (
                <animate
                  attributeName="offset"
                  values="-2; 1"
                  dur={`${props.speed}s`}
                  repeatCount="indefinite"
                />
              ) : null}
            </stop>
            <stop offset="50%" stop-color={props.secondaryColor}>
              {props.animate ? (
                <animate
                  attributeName="offset"
                  values="-1.5; 1.5"
                  dur={`${props.speed}s`}
                  repeatCount="indefinite"
                />
              ) : null}
            </stop>
            <stop offset="100%" stop-color={props.primaryColor}>
              {props.animate ? (
                <animate
                  attributeName="offset"
                  values="-1; 2"
                  dur={`${props.speed}s`}
                  repeatCount="indefinite"
                />
              ) : null}
            </stop>
          </linearGradient>
        </defs>
      </svg>
    )
  },
}
